module.exports = __webpack_public_path__ + "static/img/img-products-4.222792c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-products-4.png
// module id = 152
// module chunks = 2